import React, { useState, useEffect } from "react";

function FearGreed() {
  const [fgIndex, setFgIndex] = useState(0);
  const [fgIndexDate, setFgIndexDate] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("stats/feargreed")
      .then((resp) => resp.json())
      .then((data) => {
        setFgIndex(data.index);
        setFgIndexDate(data.indexDate);
        setLoading(false);
      })
      .catch((err) => console.log(err.message));
  }, []);

  // read any global variable from window.
  window.google.charts.load("current", { packages: ["gauge"] });
  window.google.charts.setOnLoadCallback(() => drawChart(fgIndex));

  return (
    <div className="mbox">
      <h4 className="text-center" title="Fear and Greed index measures the overall emotional state of Bitcoin. It is published daily and outputs a value between 0 (extreme fear) and 100 (extreme greed)">
        <i className="bi bi-heart-pulse-fill" style={{ color: "chocolate" }}></i>{" "}
        Fear and Greed Index
      </h4>
      {loading ? (
        <div className="text-center" style={{ fontStyle: "italic" }}>
          Loading...
        </div>
      ) : (
        <div
          style={{ color: getLevelColor(fgIndex) }}
          className="h5 text-center"
        >
          {getLevel(fgIndex)}
        </div>
      )}
      <div
        id="fgIndex"
        style={{ width: 200, height: 200, marginLeft: 65 }}
      ></div>
      <div className="text-center">
        {loading ? (
          <span>&nbsp;</span>
        ) : (
          <span style={{ fontSize: 11, color: "#000000", marginLeft: 15 }}>
            (as of {fgIndexDate})
          </span>
        )}
      </div>
      <div style={{ fontSize: 11 }} className="mt-2">
        <span className="p-2">source: alternative.me</span>
      </div>
    </div>
  );
}

function getLevel(value) {
  let level;
  if (value < 25) {
    level = "Extreme Fear";
  } else if (value < 50) {
    level = "Fear";
  } else if (value < 75) {
    level = "Greed";
  } else {
    level = "Extreme Greed";
  }
  return level;
}

function getLevelColor(value) {
  return value < 50 ? "orange" : "green";
}

function drawChart(fgIndexValue) {
  const google = window.google;

  var data = google.visualization.arrayToDataTable([
    ["Label", "Value"],
    ["", fgIndexValue],
  ]);

  var options = {
    width: 200,
    height: 200,
    greenFrom: 50,
    greenTo: 100,
    yellowFrom: 25,
    yellowTo: 49,
    redFrom: 0,
    redTo: 24,
    minorTicks: 10,
  };

  var chart = new google.visualization.Gauge(
    document.getElementById("fgIndex")
  );

  chart.draw(data, options);
}

export default FearGreed;
